// Library imports
import React from 'react';
import { Route } from 'react-router';
import * as urls from './actions/urlTypes';
import { NoMatchComponent } from './components/common/NoMatchComponent';
// Component imports
import Main from './containers/Main';
import Crosstab from './containers/Crosstab';
import SalesCatalyst from './containers/SalesCatalyst';
import ChangePassword from './containers/ChangePassword';
import CAAddNew from './containers/contractAdmin/CAAddNew';
import ContractAdmin from './containers/contractAdmin/ContractAdmin';
import admin from './containers/admin';
import UserManagement from './containers/admin/UserManagement';
import AddUserContainer from './containers/admin/AddUserContainer';
import EditUserContainer from './containers/admin/EditUserContainer';
import AccountManagement from './containers/admin/AccountManagement';
import UserPreference from './containers/UserPreference';
import CrosstabBeta from './containers/crosstabBeta';
import CrosstabDropdown from './components/crosstabBeta/CrosstabDropdown';
import CrosstabTable from './components/crosstabBeta/CrosstabTable';
import CrosstabDummy from './components/crosstabBeta/CrosstabDummy';
import QuickReports from './containers/QuickReports';
import DataHaul from './components/crosstab/DataHaulGrid/DataHaul';
import GeoMap from './containers/GeoMap';
import CacContainer from './containers/CacContainer';
import MME from './containers/MME';
import Stories from './containers/Stories';
import Insight360 from './containers/Insight360';
import TurnkeyOmnibus from './containers/TurnkeyOmnibus';
import Targets from './containers/de/Targets';
import de from './containers/de';
import Build from './containers/de/Build';
import Label from './containers/de/Label';
import Distribute from './containers/de/Distribute';
import Support from './containers/Support';
import ManageUniAccessPage from './containers/ManageUniAccessPage';
import InfoMessage from './containers/InfoMessage';
import ConcurrentUserErrorMessage from './containers/ConcurrentUserErrorMessage';
import Signup from './containers/SignUp';
import RldTool from './containers/RldTool';

export default (
  <div>
    <Route path={`/${urls.APP_ROOT_URL}`} component={Main}>
      <Route path={`${urls.APP_ROOT_URL}/caAddNew`} component={CAAddNew} />
      <Route
        path={`${urls.APP_ROOT_URL}/change-password`}
        component={ChangePassword}
      />
      <Route
        path={`${urls.APP_ROOT_URL}/ContractAdmin`}
        component={ContractAdmin}
      />
      <Route path={`${urls.APP_ROOT_URL}/admin`} component={admin}>
        <Route
          path={`${urls.APP_ROOT_URL}/admin/users`}
          component={UserManagement}
        >
          <Route
            path={`${urls.APP_ROOT_URL}/admin/users/add`}
            component={AddUserContainer}
          />
          <Route
            path={`${urls.APP_ROOT_URL}/admin/users(/:userId)`}
            component={EditUserContainer}
          />
        </Route>
        <Route
          path={`${urls.APP_ROOT_URL}/admin/accounts`}
          component={AccountManagement}
        />
      </Route>
      <Route
        path={`${urls.APP_ROOT_URL}/user-preference`}
        component={UserPreference}
      />
      <Route path="/essentials">
        <Route
          path={`${urls.APP_ROOT_URL}/essentials/crosstab`}
          component={Crosstab}
        />
        <Route path="/crosstabPOC" component={CrosstabBeta}>
          <Route
            path={`${urls.APP_ROOT_URL}/essentials/crosstabPOC/dropdown`}
            component={CrosstabDropdown}
          />
          <Route
            path={`${urls.APP_ROOT_URL}/essentials/crosstabPOC/table`}
            component={CrosstabTable}
          />
          <Route
            path={`${urls.APP_ROOT_URL}/essentials/crosstabPOC/dummy`}
            component={CrosstabDummy}
          />
        </Route>
        <Route
          path={`${urls.APP_ROOT_URL}/essentials/quickreports`}
          component={QuickReports}
        />
        <Route
          path={`${urls.APP_ROOT_URL}/essentials/datahaul`}
          component={DataHaul}
        />
        <Route
          path={`${urls.APP_ROOT_URL}/essentials/geomap`}
          component={GeoMap}
        />
        <Route
          path={`${urls.APP_ROOT_URL}/essentials/correspondencecluster`}
          component={CacContainer}
        />
        <Route path={`${urls.APP_ROOT_URL}/essentials/MME`} component={MME} />
        <Route
          path={`${urls.APP_ROOT_URL}/essentials/stories`}
          component={Stories}
        />
      </Route>
      <Route path="/catalyst">
        <Route
          path={`${urls.APP_ROOT_URL}/catalyst/brandcatalyst`}
          component={Insight360}
        />
        <Route
          path={`${urls.APP_ROOT_URL}/catalyst/salescatalyst`}
          component={SalesCatalyst}
        />
      </Route>
      <Route path="/omnibus">
        <Route
          path={`${urls.APP_ROOT_URL}/omnibus/turnkey`}
          component={TurnkeyOmnibus}
        />
      </Route>
      <Route path="/datahub" component={de}>
        <Route
          path={`${urls.APP_ROOT_URL}/datahub/targets`}
          component={Targets}
        />
        <Route path={`${urls.APP_ROOT_URL}/datahub/build`} component={Build} />
        <Route
          path={`${urls.APP_ROOT_URL}/datahub/label(/:targetID)`}
          component={Label}
        />
        <Route
          path={`${urls.APP_ROOT_URL}/datahub/distribute`}
          component={Distribute}
        />
      </Route>
      <Route path={`${urls.APP_ROOT_URL}/support`} />
      <Route path={`${urls.APP_ROOT_URL}/rldtool`} component={RldTool} />
    </Route>

    <Route
      path={`${urls.APP_ROOT_URL}/university(/:uniID)`}
      component={ManageUniAccessPage}
    />
    <Route path={`${urls.APP_ROOT_URL}/info`} component={InfoMessage} />
    <Route
      path={`${urls.APP_ROOT_URL}/error`}
      component={ConcurrentUserErrorMessage}
    />
    <Route path={`${urls.APP_ROOT_URL}/registration`} component={Signup} />
    <Route path="*" component={NoMatchComponent} />
  </div>
);
